import { DateTime, Duration } from 'luxon';

/**
 * Returns the time remaining until a reservation's expiry as an hours/minutes Duration.
 *
 * The backend already bakes weekend and holiday freezing into the expiry timestamp, so the
 * countdown is simply the wall-clock difference between the expiry and now. It must not
 * subtract days off itself, otherwise the displayed timer drifts from the real expiry.
 */
export function getCountdownToExpiry(
  expiryMillis: number,
  nowMillis: number
): Duration {
  return DateTime.fromMillis(expiryMillis).diff(
    DateTime.fromMillis(nowMillis),
    ['hours', 'minutes']
  );
}
